import { useEffect } from 'react';
export function SubmissionStatus({setSubmissionStatus, submissionStatus, csrfHookInfo}) {

  useEffect(() => {
    let timer;
    // console.log(1,submissionStatus);
    if (submissionStatus === 'success') {
      // Set a timer to reset the status to 'idle' after 3 seconds (3000ms)
      timer = setTimeout(() => {

        setSubmissionStatus('idle');

      }, 3000);
    }

    // Cleanup function to clear the timeout if the component unmounts or status changes
    return () => {
      if (timer) {
        clearTimeout(timer);
      }
    };
  }, [submissionStatus, setSubmissionStatus]);
  return (
    <h3 className="h-4">
      {csrfHookInfo.isLoading && (
        <p className="text-sm text-blue-500">Initializing form security...</p>
      )}

      {submissionStatus === 'submitting' && (
        <p className="text-sm text-blue-500">Sending message...</p>
      )}

      {submissionStatus === 'success' && (
        <p className="text-sm text-green-600 font-semibold">Message sent successfully! We&apos;ll be in touch.</p>
      )}

      {submissionStatus === 'error' && (
        <p className="text-sm text-red-600 font-semibold">
          Submission failed. Please try again. (Security Ready:
          {' '}
          {csrfHookInfo.isCsrfReady ? 'Yes' : 'No'}
          )
        </p>
      )}
    </h3>
  );
}
